function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148338",
  d: "M9.3,25.454H22.262c2.322,0,3.521-1.2,3.521-3.489V8.943c0-2.29-1.2-3.488-3.521-3.488H9.3c-2.311,0-3.521,1.188-3.521,3.488V21.966C5.782,24.256,6.991,25.454,9.3,25.454ZM12.171,20.1a1.012,1.012,0,0,1-1.017-1.027.975.975,0,0,1,.31-.706l2.911-2.921-2.911-2.911a.975.975,0,0,1-.31-.706,1,1,0,0,1,1.017-1.017.976.976,0,0,1,.728.289l2.921,2.911,2.932-2.921a.994.994,0,0,1,.728-.3,1.007,1.007,0,0,1,.706,1.734l-2.911,2.921,2.911,2.911a1.032,1.032,0,0,1,.3.717A1.014,1.014,0,0,1,19.458,20.1a1.044,1.044,0,0,1-.738-.3l-2.9-2.9-2.9,2.9A.992.992,0,0,1,12.171,20.1Z",
  transform: "translate(-5.782 -5.454)",
  fill: "currentColor"
});

function SvgXSignRoundish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSignRoundish);
export default __webpack_public_path__ + "static/media/x-sign-roundish.4ad69587.svg";
export { ForwardRef as ReactComponent };